/* eslint-disable boundaries/dependencies */
import { modalsActions } from '@entities/modal'
import { pagesDataActions } from '@entities/pagesData'

import { actions as authActions } from './_auth'
import { actions as loaderActions } from './_loader'

export const { setAuth, setAuthError, clearAuth, changeAuthStatus } =
  authActions

export const { setGlobalError, disableLoader, showLoader } = loaderActions

export const { addNewModal, closeModalById, closeAllModals } = modalsActions

export const {
  loadPageData,
  updatePageData,
  clearPageData,
  clearAllPagesData,
} = pagesDataActions
